import { dashboardConstants } from "./constants/dashboardConstants";

const getCommonReports = () => ({
  type: dashboardConstants.getCommonReportsRequest,
});

const getRevenueReport = () => ({
  type: dashboardConstants.getRevenueReportRequest,
});

const getStudentReport = (data: any) => ({
  type: dashboardConstants.getStudentReportRequest,
  payload: data,
});

const getInstructorReport = (data: any) => ({
  type: dashboardConstants.getInstructorReportRequest,
  payload: data,
});

export const dashboardActions = {
  getCommonReports,
  getRevenueReport,
  getStudentReport,
  getInstructorReport,
};
